<template>
    <base-dialog :loading="loading" :value="dialog" :width="440"
        :title="`${editMode ? $t('common.edit') : $t('common.add')} ${$t('common.team')}`"
        @input="val => { if (!val) hide() }" @close="hide">
        <div class="team-body">
            <div class="form-group">
                <span class="field-label">{{ $t('common.team') }}</span>
                <kimsa-text-field :placeholder="$t('common.name')" @change="name = $event" :value="name" force-value />
            </div>

            <div class="subgroups-section">
                <div class="subgroups-label">
                    <span>{{ $t('common.subgroup') }}s</span>
                    <v-btn class="subgroups-add-btn" icon height="24" width="24" @click="addSubgroup">
                        <v-icon size="16" color="white">mdi-plus</v-icon>
                    </v-btn>
                </div>
                <div class="subgroups-list">
                    <div class="subgroup-field" v-for="(group, i) in groups" :key="i">
                        <kimsa-text-field class="flex-grow-1" :placeholder="`${$t('common.subgroup')} ${i + 1}`"
                            @change="groups[i].name = $event" :value="groups[i].name" force-value />
                        <v-btn v-if="groups.length > 1" icon small class="subgroup-del" @click="removeSubgroup(i)">
                            <v-icon size="16" color="error">mdi-close</v-icon>
                        </v-btn>
                    </div>
                </div>
            </div>
        </div>

        <template v-slot:footer>
            <dialog-actions :confirm-label="editMode ? $t('common.edit') : $t('common.add')" :disabled="!valid"
                :loading="loading" @cancel="hide" @confirm="save" />
        </template>
    </base-dialog>
</template>

<script>
import KimsaTextField from "@/components/common/inputs/KimsaTextField";

import {db, FieldValue} from "@/utils/Firebase";
import {deleteAssignedRoutinesGroupCollection, removeStudentsFromGroup} from "@/utils/Exercises";
import BaseDialog from "@/components/common/BaseDialog";
import DialogActions from "@/components/common/DialogActions";

export default {
    name: "CreateTeamStudentsDialog",
    components: {KimsaTextField, BaseDialog, DialogActions},
    props: {
        isSecondDialog: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            dialog: false,
            name: '',
            loading: false,
            groups: [{id: 0, name: '', students: []}],
            team: null,
            editMode: false,
            groupsDeleted: [],
        }
    },
    computed: {
        valid(vm = this) {
            return vm.name.trim().length >= 3 && !vm.groups.find(group => !group.name?.trim())
        }
    },
    methods: {
        show() {
            const vm = this
            vm.dialog = true
        },
        hide() {
            const vm = this
            vm.dialog = false
            vm.reset()
        },
        reset() {
            const vm = this
            vm.name = ''
            vm.groups = [{id: 0, name: '', students: []}]
            vm.team = null
            vm.editMode = false
            vm.groupsDeleted = []
        },
        loadTeam(team) {
            const vm = this
            vm.editMode = true
            vm.name = team.name
            vm.groups = []
            vm.groups = JSON.parse(JSON.stringify(team.groups))
            vm.team = team
            vm.show()
        },
        async save() {
            const vm = this
            await vm.withLoading(async () => {
                if(vm.editMode) {
                    if(vm.groupsDeleted.length > 0) {
                        for (let group of vm.groupsDeleted) {
                            await deleteAssignedRoutinesGroupCollection(group.id, vm.team.id)
                            await removeStudentsFromGroup(group.students || [])
                        }
                    }

                    await db.collection('teams').doc(vm.team.id).update({
                        name: vm.name,
                        groups: vm.groups,
                    })
                    vm.toast(vm.$t('common.team_edited'))
                } else {
                    await db.collection('teams').add({
                        coachId: vm.currentUser.uid,
                        name: vm.name,
                        groups: vm.groups
                    })

                    await db.collection('users').doc(vm.currentUser.uid).update({
                        teamsQuantity: FieldValue.increment(1),
                    })

                    vm.toast(vm.$t('common.team_added'))
                }

                vm.hide()
            })
        },
        addSubgroup() {
            const vm = this
            let groupId = vm.groups[vm.groups.length - 1].id + 1
            vm.groups.push({id: groupId, name: '', students: []})
        },
        removeSubgroup(index) {
            const vm = this
            vm.groupsDeleted.push(vm.groups[index])
            vm.groups.splice(index, 1)
        }
    },

}
</script>

<style scoped>
.team-body {
    display: flex;
    flex-direction: column;
    gap: 16px;
}

.form-group {
    display: flex;
    flex-direction: column;
    gap: 6px;
}

.field-label {
    font-size: 12px;
    font-weight: 600;
    color: var(--v-txtSecondary-base);
}

.subgroups-label {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 13px;
    font-weight: 600;
    color: var(--v-txtSecondary-base);
    margin-bottom: 10px;
}

.subgroups-add-btn {
    background: var(--v-accent-base) !important;
}

.subgroups-list {
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.subgroup-field {
    display: flex;
    align-items: center;
    gap: 8px;
}
</style>